module.exports = __webpack_public_path__ + "img/19239132532c57aebe9aa97c46d1c3d8.png";